import { Component, OnInit } from '@angular/core';
import { SignupWizardService } from '../signup-wizard.service';

/**
 * @deprecated - This step is not used in the signup flow currently
 */
@Component({
  standalone: false,
  selector: 'sbnb-signup-menu',
  templateUrl: './signup-menu.component.html',
  styleUrls: ['./signup-menu.component.scss'],
})
export class SignupMenuComponent implements OnInit {
  loading: boolean;

  constructor(public wizard: SignupWizardService) { }

  ngOnInit() {
    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    }
  }

  onboardingSelected(type: string) {
    this.loading = true;

    this.wizard.updateOnboarding(type).subscribe((res) => {
      this.loading = false;
      this.wizard.next();
    });
  }
}
